module.exports = __webpack_public_path__ + "static/media/2.27fb63e2.JPG";